import { render, staticRenderFns } from "./SingaporeMusic.vue?vue&type=template&id=078082a4&scoped=true&"
import script from "./SingaporeMusic.vue?vue&type=script&lang=js&"
export * from "./SingaporeMusic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078082a4",
  null
  
)

export default component.exports